import { useEffect, useState } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import { Loader2, XCircle } from "lucide-react";
import LogoType from "@/components/LogoType";
import BookingCalendar from "@/components/BookingCalendar";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function Reschedule() {
  const [appt, setAppt] = useState(undefined); // undefined=loading, null=not found
  const [moved, setMoved] = useState(false);
  const params = new URLSearchParams(window.location.search);
  const sessionId = params.get("session_id");

  useEffect(() => {
    if (!sessionId) { setAppt(null); return; }
    axios.get(`${API}/appointments/${sessionId}`)
      .then((r) => setAppt(r.data && r.data.session_id ? r.data : null))
      .catch(() => setAppt(null));
  }, [sessionId]);

  return (
    <div className="min-h-screen flex flex-col items-center justify-center px-6 py-16 text-center">
      <Link to="/" className="mb-10"><LogoType size="md" /></Link>

      {appt === undefined && (
        <div className="flex items-center gap-2 text-[#B7A488]" data-testid="reschedule-loading">
          <Loader2 className="w-5 h-5 animate-spin" /> Finding your booking…
        </div>
      )}

      {appt === null && (
        <div className="gold-frame rounded-sm bg-[#1F130E] p-10 max-w-md w-full flex flex-col items-center" data-testid="reschedule-notfound">
          <XCircle className="w-12 h-12 text-[#C77E8A] mb-6" strokeWidth={1.2} />
          <h1 className="font-display text-3xl text-[#EFE3CC]">We couldn't find that booking</h1>
          <p className="mt-3 text-[#B7A488] font-light">The link may have expired. Please reach out and we'll help you reschedule.</p>
          <Link to="/" className="mt-8 rounded-full border border-[#C9A24B]/45 px-8 py-3 text-xs tracking-[0.2em] uppercase text-[#EFE3CC] hover:border-[#C9A24B] hover:bg-[#C9A24B]/10 transition-all">Back to Home</Link>
        </div>
      )}

      {appt && appt.session_id && (
        <div className="w-full flex flex-col items-center" data-testid="reschedule-page">
          <span className="text-[11px] tracking-[0.3em] uppercase text-[#C9A24B] mb-2">✦ Reschedule ✦</span>
          {!moved && (
            <p className="text-sm text-[#B7A488] font-light mb-8">Currently booked for {appt.date} at {appt.time}. Pick a new date & time below.</p>
          )}
          <BookingCalendar sessionId={sessionId} tierName={appt.tier_name} initialName={appt.name} initialEmail={appt.email} mode="reschedule" onDone={() => setMoved(true)} />
        </div>
      )}
    </div>
  );
}
